import React from "react";

import Typography from "@mui/material/Typography";

import DateChip from "components/DateChip";
import { PillSelect } from "components/PillSelect";
import { MobileCard } from "components/DataTable";

import { getPriceFormat } from "shared/functions";

import { IbanInvoicePayment } from "store/features/ibanInvoiceSlice";

import { paymentStatusOptions } from "../columns";

import dayjs from "dayjs";

export interface InvoicePaymentMobileCardProps {
  row: IbanInvoicePayment;
  onStatusChange: (payment: IbanInvoicePayment, status: string) => void;
}

const InvoicePaymentMobileCard: React.FC<InvoicePaymentMobileCardProps> = (
  props,
) => {
  const { row, onStatusChange } = props;

  const { paymentInitiatedDateUtc, amount, paymentPurpose, status } = row;
  const paymentDate = dayjs
    .utc(paymentInitiatedDateUtc)
    .local()
    .format("DD MMM YY, HH:mm");

  const paymentAmount = getPriceFormat(Number(amount ?? 0));

  return (
    <MobileCard>
      <MobileCard.Header
        actions={
          <PillSelect
            value={status}
            onChange={(status) => onStatusChange(row, status)}
            options={paymentStatusOptions}
          />
        }
      >
        <span />
      </MobileCard.Header>
      <MobileCard.Body divider>
        <DateChip date={paymentDate} />
        <Typography variant="body2" sx={{ mt: 1.5 }}>
          {paymentPurpose}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1.5 }}>
          {paymentAmount} ₴
        </Typography>
      </MobileCard.Body>
    </MobileCard>
  );
};

export default InvoicePaymentMobileCard;
